import { ref, onMounted } from 'vue';

export interface UseDelayedStateOptions {
  delay?: number;
  initialValue?: boolean;
  triggerOnMount?: boolean;
}

export function useDelayedState(options: UseDelayedStateOptions = {}) {
  const {
    delay = 400,
    initialValue = false,
    triggerOnMount = true
  } = options;

  const state = ref(initialValue);

  const triggerWithDelay = (newState?: boolean) => {
    const targetState = newState !== undefined ? newState : !state.value;

    setTimeout(() => {
      state.value = targetState;
    }, delay);

    return targetState;
  };

  const setImmediate = (newState: boolean) => {
    state.value = newState;
    return newState;
  };

  if (triggerOnMount) {
    onMounted(() => {
      triggerWithDelay(!initialValue);
    });
  }

  return {
    state,
    triggerWithDelay,
    setImmediate
  };
}
